// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2lr0A","author":"Table_author__gZJ34","authorImage":"Table_authorImage__2W_7h","unreadRow":"Table_unreadRow__2X_m8"};